import { format } from "date-fns";
import { fr } from "date-fns/locale";

export interface ReservationExportData {
  id: number;
  supabaseId: string;
  time: string;
  name: string;
  persons: number;
  numberOfChildren?: number;
  tableId: string | undefined;
  combinedTableId: string | undefined;
  status: "planifié" | "arrivé" | "annulé" | "en_attente";
  phone: string;
  email: string | undefined;
  reservationDate: Date;
  createdAt: Date;
  notes: string | undefined;
  internalNotes: string | undefined;
  hasStroller?: boolean;
  source?: string;
}

/**
 * Converts reservation data to CSV format and triggers download
 */
export const exportReservationsToCSV = (
  reservations: ReservationExportData[],
  tables: Array<{ id: string; name: string }>,
  combinedTables: Array<{ id: string; name: string }>
) => {
  // Create CSV headers
  const headers = [
    "ID",
    "Date",
    "Heure",
    "Nom",
    "Email",
    "Téléphone",
    "Nb Personnes",
    "Enfants",
    "Poussette",
    "Table",
    "Statut",
    "Notes client",
    "Notes internes",
    "Source",
    "Date de création"
  ];

  // Convert reservations to CSV rows
  const rows = reservations.map(reservation => {
    // Find table name
    let tableName = "";
    if (reservation.tableId) {
      const table = tables.find(t => t.id === reservation.tableId);
      tableName = table?.name || reservation.tableId;
    } else if (reservation.combinedTableId) {
      const combinedTable = combinedTables.find(ct => ct.id === reservation.combinedTableId);
      tableName = combinedTable?.name || reservation.combinedTableId;
    }

    return [
      reservation.id,
      format(reservation.reservationDate, "dd/MM/yyyy", { locale: fr }),
      reservation.time,
      `"${reservation.name}"`, // Wrap in quotes to handle commas in names
      reservation.email || "",
      reservation.phone,
      reservation.persons,
      reservation.numberOfChildren || 0,
      reservation.hasStroller ? "Oui" : "Non",
      tableName,
      reservation.status,
      `"${(reservation.notes || "").replace(/"/g, '""')}"`, // Escape quotes
      `"${(reservation.internalNotes || "").replace(/"/g, '""')}"`, // Escape quotes
      reservation.source || "",
      format(reservation.createdAt, "dd/MM/yyyy HH:mm", { locale: fr })
    ];
  });

  // Combine headers and rows
  const csvContent = [
    headers.join(","),
    ...rows.map(row => row.join(","))
  ].join("\n");

  // Add BOM for Excel compatibility with UTF-8
  const BOM = "\uFEFF";
  const csvWithBOM = BOM + csvContent;

  // Create blob and download
  const blob = new Blob([csvWithBOM], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  
  const filename = `reservations_${format(new Date(), "yyyy-MM-dd_HH-mm")}.csv`;
  
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
